import * as React from 'react';
import { useTooltipController } from './useTooltipController';
import { CustomTooltip } from '../CustomTooltip';

/**
 * Компонент подсказки в виде всплывающего текста
 *
 * @export
 * @param {ITooltipProps} props
 * @returns
 */
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function TooltipDesktop(props) {
  const {
    theme = 'black',
    placement,
    title,
    portal,
    arrow
  } = props;
  const {
    childrenProps,
    tooltipProps
  } = useTooltipController(props);
  const {
    open,
    anchorRef,
    onMouseEnter,
    onMouseLeave
  } = tooltipProps;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/React.cloneElement(props.children, childrenProps), /*#__PURE__*/_jsx(CustomTooltip, {
      open: open,
      anchorRef: anchorRef,
      content: title,
      placement: placement,
      theme: theme,
      portal: portal,
      arrow: arrow,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    })]
  });
}